// @flow
import CompetitionDetail from 'components/competition/CompetitionDetail';
import { connect } from 'react-redux';

import type { DispatchProps, StateProps } from 'components/competition/CompetitionDetail';
import type { DispatchType, StateType } from 'types/Actions';
import { fetchCompetition } from 'actions/competitionActions';

export default connect(
  (state: StateType): StateProps => ({
    competition: state.competitionState.competition,
    ligue_id: state.settingsState.ligue_id,
    status: state.competitionState.status
  }),
  (dispatch: DispatchType): DispatchProps => ({
    fetchCompetition: (slug: string, ligue_id: number) => dispatch(fetchCompetition(slug, ligue_id))
  })
)(CompetitionDetail);
